// extracted by mini-css-extract-plugin
export var border = "_23-7";
export var brand = "_23-s";
export var button = "_23-k";
export var center = "_23-9";
export var centered = "_23-5";
export var closeButton = "_23-b";
export var disabledWrapper = "_23-l";
export var error = "_23-o";
export var extraLarge = "_23-4";
export var extraSmall = "_23-1";
export var fill = "_23-h";
export var footer = "_23-g";
export var footerAction = "_23-i";
export var footerButtons = "_23-j";
export var header = "_23-6";
export var headerWithClose = "_23-c";
export var icon = "_23-n";
export var info = "_23-r";
export var inline = "_23-8";
export var large = "_23-3";
export var main = "_23-d";
export var modal = "_23-0";
export var neutral = "_23-t";
export var noPadding = "_23-f";
export var none = "_23-u";
export var scrollable = "_23-e";
export var small = "_23-2";
export var success = "_23-q";
export var tight = "_23-m";
export var titleIcon = "_23-a";
export var warn = "_23-p";